import { combineReducers } from 'redux';

// Reducers
import profession from './profession';
import position from './position';
import countryNationality from './countryNationality';
import workActivity from './workActivity';
import personalData from './personalData';
import identity from './identity';
import uf from './uf';
import indicators from './indicators';
import participationFees from './participationFees';
import offices from './offices';
import executive from './executive';
import banks from './banks';
import accountsTypes from './accountsTypes';
import documents from './documents';
import signature from './signature';
import paymentButton from './paymentButton';
import survey from './survey';
import otp from './otp';
import password from './password';
import loaders from './ui_loaders';
import coverage from './coverage';
import abonoInicial from './abonoInicial'

const reducers = combineReducers({
  entities: combineReducers({
    profession,
    position,
    countryNationality,
    workActivity,
    personalData,
    identity,
    uf,
    indicators,
    participationFees,
    offices,
    executive,
    banks,
    accountsTypes,
    documents,
    signature,
    paymentButton,
    otp,
    password,
    survey,
    coverage,
    abonoInicial
  }),
  ui: combineReducers({
    loaders,
  }),
});

export default reducers;
